<template>
  <div class="box2">
    <vue-seamless-scroll
      :data="tabList"
      :class-option="classOption1"
      class="seamless-warp"
    >
      <div class="demo">
        <div class="item" v-for="(item, index) in tabList" :key="index">
          <p>{{ item.tit }}</p>
          <p>{{ item.txt }}</p>
        </div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      tabList: [
        { tit: "离线数仓能力", txt: "满足企业搭建数仓的需求" },
        { tit: "实时数仓能力", txt: "满足企业搭建实时数仓的需求" },
        { tit: "BI开发能力", txt: "解决企业数据可视化问题" },
        { tit: "调度脚本编写能力", txt: "解决大数据任务调度问题" },
      ],
    };
  },
  computed: {
    classOption1() {
      return {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
};
</script>

<style lang="less" scoped>
.box2 {
  padding-bottom: 50px;
  width: 100%;
  background: linear-gradient(180deg, #feffff 0%, #e8f8ff 100%);

  .seamless-warp {
    margin-top: 64px;
    width: 100%;
    overflow: hidden;
    position: relative;
    z-index: 9;
    margin-top: -28px;
    .demo {
      display: flex;
    }
    .item {
      width: 404px;
      height: 160px;
      background: linear-gradient(180deg, #e5f6ff 0%, #ffffff 100%);
      box-shadow: 0px 12px 32px 0px rgba(0, 0, 0, 0.04);
      border-radius: 16px;
      border: 2px solid #ffffff;
      padding: 32px 0 32px 32px;
      flex-shrink: 0;
      box-sizing: border-box;
      margin-left: 16px;
      p:nth-child(1) {
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #0080ff;
        line-height: 44px;
      }
      p:nth-child(2) {
        margin-top: 8px;
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #525366;
        line-height: 44px;
      }
    }
    .item:first-child {
      margin-left: 32px;
    }
  }
}
</style>
